import { PeriodType } from './types';

export const isPeriodType = (p: unknown): p is PeriodType =>
  Object.values(PeriodType).includes(p as PeriodType);
